import React, { useState, useCallback, useMemo } from "react";

import joyrideService from "src/shared/services/joyride.service";
import { JoyrideState } from "src/shared/types";
export interface IJoyride {
  showJoyrideMap: { [key in JoyrideState]: boolean };
  cancelJoyride: (key: JoyrideState) => void;
}

export const JoyrideContext = React.createContext<IJoyride | null>(null);
export const JoyrideProvider = JoyrideContext.Provider;

export default () => {
  const joyrideMap = useMemo(() => {
    const joyrideObject: { [key in JoyrideState]: boolean } = {
      MANAGE_METRICS: false,
      TAKE_NOTES: false,
      HOME: false,
      CATEGORY: false,
      SEARCH: false,
      ALLORGMETRICS: false,
      DETAILS: false,
    };
    for (const component in JoyrideState) {
      joyrideObject[component] = joyrideService.show;
    }
    return joyrideObject;
  }, [JoyrideState]);

  const [showJoyrideMap, setShowJoyride] = useState(joyrideMap);

  const cancelJoyride = useCallback(
    (key: JoyrideState) => {
      setShowJoyride({ ...showJoyrideMap, [key]: false });
    },
    [showJoyrideMap]
  );

  return { showJoyrideMap, cancelJoyride };
};
